import { Component } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { BalancesLabels } from '../../i18n/balances-labels';
import { CurrencyBalancesBaseGrid } from './currency-balances-base-grid';
import { CurrencyBalancesCellrenderComponent } from './currency-balances-cellrender.component';
import { BalancesService } from '../../services/balances.services';
import { MatDialog } from '@angular/material/dialog';
import { ForeignExchangeComponent } from '@pershing/nxi-ng-rateboard';
import { ColDef} from '@ag-grid-community/all-modules';

@Component({
    selector: 'currency-balances-mobile-grid',
    templateUrl: './currency-balances-mobile-grid.component.html'
})

export class CurrencyBalancesMobileGridComponent extends CurrencyBalancesBaseGrid {
    currentDate: string = '';
    autoGroupColumnDef: ColDef = {};
    constructor(
        private translationService: PershingTranslationService,
        balancesService: BalancesService,
        private balanceService: BalancesService,
        private dialog: MatDialog,
    ) {
        super(balancesService);
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.balanceService.getForeignExchangeData().subscribe(resp => {
            if(resp.response && resp.response.length > 0){
                this.currentDate = resp.response[0].convertedAsOfDate;
            }
        });
    }

    createColumnDefs() {
        let colDefs: any[] = [
            {
                headerName: BalancesLabels.CURRENCY_LABELS_BALANCETYPECAP,
                cellRendererFramework: CurrencyBalancesCellrenderComponent
            },
            {
                headerName: BalancesLabels.CURRENCY_LABELS_CASHBALANCECAP,
                headerClass: 'ag-cell-label-container',
                cellClass: 'right-align',
                cellRendererFramework: CurrencyBalancesCellrenderComponent
            }
        ];
        this.columnDefs = colDefs;
        this.autoGroupColumnDef = {
            headerName: '',
            cellRendererParams: { suppressCount: false },
            width: 20 
        }
        
    }

    

    ngOnDestroy(): void {
        // Remove disclaimers.
        this.getLegend(BalancesLabels.DISCLAIMER_CASHBALANCE, false, 'cashBalance');
        this.getLegend(BalancesLabels.DISCLAIMER_MARKETVALUE, false, 'marketValue');
    }
    foreignExchangePopup() {
        this.dialog.open(ForeignExchangeComponent, { disableClose: true, width: "650px", panelClass: ['modal', 'bal-ForeignExchangeDialog']});
    }
}
